export default __webpack_public_path__ + "static/media/loading.1952935e.gif";